import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { debounceTime, fromEvent, map, tap } from 'rxjs';

@Component({
  selector: 'app-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent {

  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(): void {   
    this.titleService.setTitle('Vocbot.AI Technologies Pvt. Ltd.');
  }

  showBtn$ = fromEvent(document, 'scroll').pipe(
    debounceTime(50),
    map(() => window.scrollY > 500),
    tap(() => console.log('sas'))
  );

  // not Cross browsing (works on chrome - firefox)
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

}
